export default "__VITE_ASSET__hi6PqixC__"